export default {
  path: 'resultados',
  name: 'results',
  component: () => import('@/views/results/index.vue'),
  meta: {
    title: 'Procurar Resultados'
  }
}
